import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-location",
  "use": "icon-location-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-location\">\n  <path d=\"M512 85.333333c-164.949333 0-298.666667 133.717333-298.666667 298.666667 0 224 298.666667 554.666667 298.666667 554.666667s298.666667-330.666667 298.666667-554.666667c0-164.949333-133.717333-298.666667-298.666667-298.666667z m0 405.333334c-58.88 0-106.666667-47.786667-106.666667-106.666667s47.786667-106.666667 106.666667-106.666667 106.666667 47.786667 106.666667 106.666667-47.786667 106.666667-106.666667 106.666667z\" fill=\"currentColor\" p-id=\"17427\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/location.svg
// module id = WhFt
// module chunks = 117